<div class="tenant-contract-info">
  <app-text-input
    [label]="'tenantConfiguration.contracts.startDate' | translate"
    [value]="formattedDate(contract().start)"
    (input)="updateDate('start', $event)"
    [type]="'date'"
    direction="VERTICAL"
    [disabled]="isReadMode"
    data-test-id="tenant-contract-start-date-input"
  />
  <app-text-input
    [label]="'tenantConfiguration.contracts.expirationDate' | translate"
    [type]="'date'"
    [disabled]="isReadMode"
    [value]="formattedDate(contract().expiration)"
    (input)="updateDate('expiration', $event)"
    direction="VERTICAL"
    data-test-id="tenant-contract-expiration-date-input"
  />
  <app-text-input
    [label]="'tenantConfiguration.contracts.employeePopulation' | translate"
    direction="VERTICAL"
    [(value)]="contract().employeePopulation"
    [disabled]="isReadMode"
    data-test-id="tenant-contract-employee-population-input"
  />
  <app-text-input
    [label]="'tenantConfiguration.contracts.numberOfLicenses' | translate"
    direction="VERTICAL"
    [(value)]="contract().numberOfLicenses"
    [type]="'number'"
    [disabled]="isReadMode"
    data-test-id="tenant-contract-number-of-licenses-input"
  />
  <div class="field-group">
    <p class="label">
      {{ 'tenantConfiguration.contracts.paymentType' | translate }}
    </p>
    <app-select-dropdown
      [options]="paymentTypes"
      [selected]="contract().paymentType"
      (handleSelect)="updateContractProperty('paymentType', $event)"
      [disabled]="isReadMode"
      data-test-id="tenant-contract-payment-type-select"
    />
  </div>
  <app-text-input
    [label]="'tenantConfiguration.contracts.paymentAmount' | translate"
    direction="VERTICAL"
    [(value)]="contract().paymentAmount"
    [disabled]="isReadMode"
    data-test-id="tenant-contract-payment-amount-input"
  />
  <div class="field-group">
    <p class="label">
      {{ 'tenantConfiguration.contracts.companyType' | translate }}
    </p>
    <app-select-dropdown
      [options]="companyTypes"
      [selected]="contract().companyType"
      (handleSelect)="updateContractProperty('companyType', $event)"
      [disabled]="isReadMode"
      data-test-id="tenant-contract-company-type-select"
    />
  </div>
</div>
